declare namespace $ {

	export class $mol_icon_pencil_box extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=box.view.tree.d.ts.map